import { TechUseCaseIcon3D, TechUseCaseIconBuilding } from '@assets/images/technology/common';
import {
  IconAnalytics,
  IconBattery,
  IconCar,
  IconChartInv,
  IconHeart,
  IconHome,
  IconLocation,
  IconRulerInv,
  IconSecurity,
  IconTagInv,
} from '@assets/images/icon';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

export default {
  seo: {
    title: 'Geofence là gì? | ORBRO',
    desc: 'Geofence là công nghệ định nghĩa vùng địa lý ảo và phát hiện sự kiện trong vùng đó. Kết hợp dịch vụ định vị và cảm biến, nó cho phép phát hiện và phản ứng theo thời gian thực khi có sự kiện xảy ra trong khu vực cụ thể.',
    keywords:
      'geofence, rtls, geofence, định vị thời gian thực, digital twin, chuyển đổi số, digital twin, tòa nhà thông minh, thực tế ảo, định vị, beacon, orbro, Kong-tech',
    img: '',
    url: 'https://orbro.io/vi/enterprise/technology/what-is-geofence',
    type: 'website',
  },

  tag: 'What is Geofence?',
  title: 'Geofence là gì?',
  desc: '',

  text: [
    {
      head: 'Geofence là gì?',
      desc: 'Geofence là công nghệ thiết lập một vùng địa lý ảo và phát hiện các sự kiện xảy ra bên trong vùng đó. Công nghệ này kết hợp dịch vụ định vị và cảm biến để có thể phát hiện và phản ứng kịp thời với các sự kiện trong khu vực cụ thể theo thời gian thực.',
      subHead: '',
      dot: '',
    },
    {
      video: video,
      link: 'https://orbro.io/vi/enterprise/construction/safety',
      head: 'Công nghệ Geofence',
      desc: 'Thông thường, Geofence dựa trên GPS (Global Positioning System), nhưng gần đây có xu hướng ứng dụng công nghệ RTLS (Real-Time Location System). RTLS cung cấp thông tin vị trí chính xác hơn GPS và hoạt động hiệu quả ngay cả trong môi trường trong nhà. Bằng cách theo dõi vị trí thời gian thực thông qua beacon, RFID, mạng cảm biến, Geofence có thể được triển khai một cách hiệu quả.',
      subHead: [
        {
          title: 'RTLS là gì?',
          desc: 'RTLS (Hệ thống định vị thời gian thực) là công nghệ theo dõi vị trí của đối tượng trong thời gian thực, khác với GPS, nó cung cấp thông tin vị trí chính xác ngay cả trong môi trường trong nhà. Hệ thống này sử dụng beacon, RFID, mạng cảm biến để phát hiện và ghi lại vị trí đối tượng một cách liên tục. RTLS được ứng dụng rộng rãi trong nhiều lĩnh vực như theo dõi xe cộ, tự động hóa, an ninh, v.v.',
        },
        {
          title: 'Ưu điểm của RTLS',
          desc: 'Ưu điểm chính của RTLS là độ chính xác cao, có thể theo dõi vị trí chính xác trong môi trường trong nhà và các môi trường phức tạp mà GPS không thể đáp ứng. Khả năng phát hiện thời gian thực giúp giám sát chuyển động của đối tượng liên tục, từ đó cho phép phản ứng nhanh chóng và tự động hóa hiệu quả. Ngoài ra, RTLS có thể tích hợp nhiều công nghệ khác nhau, nên ứng dụng đa dạng trong nhiều ngành nghề. RTLS đặc biệt được đánh giá là giải pháp hiệu quả giúp nâng cao năng suất và tăng cường an ninh trong môi trường công nghiệp.',
        },
        {
          title: 'Ứng dụng RTLS',
          desc: 'Việc triển khai công nghệ RTLS đòi hỏi tích hợp nhiều thành phần khác nhau. Đầu tiên, lựa chọn và bố trí beacon, cảm biến RFID hoặc các công nghệ định vị khác để nhận diện đối tượng. Sau đó, các thiết bị được kết nối vào mạng để thu thập dữ liệu vị trí thời gian thực. Hệ thống điều khiển trung tâm sẽ xử lý và khai thác dữ liệu hiệu quả. Cuối cùng, giao diện người dùng được thiết lập để giám sát thông tin vị trí và thực hiện các hành động cần thiết.',
        },
      ],
      dot: '',
    },
    {
      tag: 'noBottomLine',
      head: 'Các lĩnh vực ứng dụng của Geofence',
      desc: 'Geofence được ứng dụng rộng rãi trong nhiều lĩnh vực, chủ yếu bao gồm:',
      subHead: [
        {
          title: 'Hệ thống an ninh',
          desc: 'Geofence giúp tăng cường an ninh bằng cách phát hiện và cảnh báo các hành vi xâm nhập trái phép tại các khu vực như tòa nhà doanh nghiệp, khu dân cư, các khu vực công cộng. Nó còn được dùng như hệ thống kiểm soát ra vào và cảnh báo trước tại các khu vực nguy hiểm',
        },
        {
          title: 'Theo dõi phương tiện',
          desc: 'Các công ty vận chuyển và xe tải sử dụng geofence để giám sát vận hành, cảnh báo khi xe ra/vào khu vực định sẵn, đảm bảo an toàn và kiểm soát chuỗi cung ứng.',
        },
        {
          title: 'Thành phố thông minh & IoT',
          desc: 'Trong ngành vận tải xe hơi hoặc vận chuyển hàng hóa, Geofence cho phép theo dõi chuyển động của phương tiện theo thời gian thực và có thể thiết lập cảnh báo khi phương tiện ra khỏi vùng giới hạn cho phép.',
        },
        {
          title: 'Giải trí và nghỉ dưỡng',
          desc: 'Tại các điểm du lịch hoặc công viên giải trí, Geofence giúp theo dõi di chuyển của khách tham quan để nâng cao dịch vụ. Đồng thời, có thể thiết lập ranh giới di động nhằm hỗ trợ hoặc giới hạn các hoạt động trong khu vực nhất định.',
        },
      ],
      dot: '',
    },
    {
      videoDesc: '(Quản lý an toàn tại công trường xây dựng, bấm vào đây để chuyển đến)',
      tag: 'noBottomLine',
      head: 'Triển vọng công nghệ Geofence',
      desc: 'Công nghệ Geofence đang tiếp tục phát triển và dự kiến sẽ mở rộng hơn nữa trong tương lai. Với sự tiến bộ công nghệ, khả năng định vị chính xác và phát hiện thời gian thực sẽ được nâng cao, góp phần mở rộng ứng dụng trong các lĩnh vực an ninh và an toàn.<br/>Ngoài ra, sự phát triển của công nghệ định vị trong nhà giúp xác định chính xác vị trí đối tượng bên trong các tòa nhà, mở rộng khả năng ứng dụng trong theo dõi phương tiện, tự động hóa công nghiệp, thành phố thông minh và nhiều lĩnh vực khác. Việc tích hợp với các hệ thống hợp tác, kết nối đa dạng các cảm biến và công nghệ khác sẽ thúc đẩy phát triển các giải pháp Geofence hiệu quả hơn. Những tiến bộ này hứa hẹn sẽ mang lại sự đổi mới lớn trong các ngành an ninh, logistics, và thành phố thông minh.',
    },
    {
      tag: 'card',
      head: '',
      desc: '',
      subHead: '',
      dot: '',
    },
    {
      tag: 'advantage',
      head: '',
      desc: '',
      subHead: '',
      dot: '',
    },
  ],

  card: {
    title: 'Các trường hợp sử dụng Geofence',
    desc: 'Công nghệ Geofence được ứng dụng hiệu quả trong nhiều lĩnh vực khác nhau. Dưới đây là một số ví dụ điển hình về các trường hợp sử dụng Geofence:',
    cards: [
      {
        icon: IconSecurity,
        title: 'Hệ thống bảo mật và cảnh báo',
        desc: [
          {
            title: 'Bảo vệ tòa nhà và cơ sở vật chất',
            desc: 'Geofence cho phép thiết lập ranh giới ảo quanh các tòa nhà hoặc cơ sở, giúp phát hiện và cảnh báo ngay lập tức khi có xâm nhập trái phép, từ đó tăng cường an ninh.',
          },
          {
            title: 'Bảo vệ xe cộ và phương tiện vận tải',
            desc: 'Áp dụng Geofence vào xe ô tô hoặc phương tiện vận chuyển để hỗ trợ phòng chống trộm cắp và đảm bảo vận hành an toàn.',
          },
        ],
      },
      {
        icon: IconHome,
        title: 'Tối ưu hóa giao hàng và vận chuyển',
        desc: [
          {
            title: 'Theo dõi hàng hóa thời gian thực',
            desc: 'Ứng dụng Geofence trong mạng lưới logistics để giám sát vị trí hàng hóa theo thời gian thực, góp phần quản lý kho bãi hiệu quả hơn.',
          },
          {
            title: 'Tối ưu hóa giao hàng và vận chuyển',
            desc: 'Sử dụng Geofence để tối ưu hóa tuyến đường giao hàng và vận chuyển, giảm chi phí và nâng cao tốc độ dịch vụ.',
          },
        ],
      },
      {
        icon: IconHeart,
        title: 'An ninh cơ sở y tế',
        desc: [
          {
            title: 'Theo dõi vị trí bệnh nhân',
            desc: 'Trong bệnh viện hoặc cơ sở y tế, Geofence giúp theo dõi vị trí bệnh nhân theo thời gian thực, hỗ trợ ứng phó nhanh với các tình huống khẩn cấp.',
          },
          {
            title: 'Quản lý thiết bị y tế',
            desc: 'Áp dụng Geofence để giám sát vị trí và trạng thái thiết bị y tế, đảm bảo dịch vụ y tế chính xác và hiệu quả.',
          },
        ],
      },
      {
        icon: TechUseCaseIconBuilding,
        title: 'An toàn thành phố thông minh',
        desc: [
          {
            title: 'Giám sát nơi công cộng',
            desc: 'Thiết lập Geofence tại các điểm trọng yếu trong thành phố để tăng cường an toàn công cộng và hỗ trợ phòng ngừa tội phạm.',
          },
          {
            title: 'Quản lý luồng giao thông',
            desc: 'Ứng dụng Geofence trong mạng lưới đường bộ và giao thông để theo dõi và quản lý luồng giao thông, xây dựng kế hoạch giao thông hiệu quả.',
          },
        ],
      },
      {
        icon: IconLocation,
        title: 'An ninh cơ sở giáo dục',
        desc: [
          {
            title: 'Bảo vệ trường học và khuôn viên đại học',
            desc: 'Xây dựng Geofence trong trường học hoặc khuôn viên đại học để đảm bảo an toàn cho học sinh, sinh viên và nhân viên, ngăn chặn việc ra vào trái phép.',
          },
          {
            title: 'Theo dõi tài nguyên giáo dục',
            desc: 'Sử dụng Geofence để quản lý hiệu quả các thiết bị và tài nguyên giáo dục, ngăn ngừa mất mát.',
          },
        ],
      },
      {
        icon: IconAnalytics,
        title: 'Giám sát môi trường',
        desc: [
          {
            title: 'Giám sát môi trường tự nhiên',
            desc: 'Việc ứng dụng Geofence trong môi trường tự nhiên giúp theo dõi thời gian thực các yếu tố môi trường như chất lượng không khí, chất lượng nước, khí hậu, từ đó góp phần bảo vệ môi trường.',
          },
          {
            title: 'Quản lý môi trường công nghiệp',
            desc: 'Trong các cơ sở công nghiệp, Geofence được sử dụng để giám sát các tham số môi trường và cung cấp dữ liệu chính xác, góp phần vận hành thân thiện với môi trường.',
          },
        ],
      },
    ],
  },

  advantage: {
    title: 'Ưu điểm nổi bật của Geofence',
    cards: [
      {
        icon: IconRulerInv,
        title: 'Phát hiện & cảnh báo theo thời gian thực',
        desc: 'Geofence giám sát vị trí tức thì và cảnh báo ngay khi có xâm nhập hoặc rời khỏi vùng, hỗ trợ phản ứng nhanh và chính xác.',
      },
      {
        icon: IconTagInv,
        title: 'Mô phỏng đa kịch bản',
        desc: 'Geofence cho phép thiết lập ranh giới ảo và mô phỏng trước các tình huống, hỗ trợ tối ưu logistics, giao thông và các quy trình khác.',
      },
      {
        icon: IconChartInv,
        title: 'Tiết kiệm chi phí & kéo dài tuổi thọ tài sản',
        desc: 'Theo dõi vị trí và trạng thái tài sản theo thời gian thực giúp tối ưu lịch bảo trì, tiết kiệm chi phí và gia tăng tuổi thọ thiết bị.',
      },
    ],
  },
};
